/* eslint semi: "error" */
/* eslint-disable */
function deepCopy(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  var newobj = {};
  for (var attr in obj) {
    newobj[attr] = obj[attr];
  }
  return newobj;
}

export const getOptionConfig = (barData, lang) => {

  var xData = [], yData = [];

  barData.map((a, b) => {
    xData.push(a.name);
    yData.push(a.value);
  });

  var startColor = ['#1590D7', '#FFC82A'];
  var endColor = ['#00F4D3', '#FFF0AE'];
  var RealData = [];
  var borderData = [];

  barData.map((item, index) => {
    var newobj = deepCopy(item)
    var newobj1 = deepCopy(item)
    RealData.push(newobj)
    borderData.push(newobj1)
  });

  //主要展示层数据
  RealData.map((item, index) => {
    item.itemStyle = {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: startColor[index] // 0% 处的颜色
          }, {
            offset: 1,
            color: endColor[index] // 100% 处的颜色
          }],
          globalCoord: false // 缺省为 false
        },
      }
    }
  });

  //边框层
  borderData.map((item, index) => {
    item.itemStyle = {
      normal: {
        color: "rgba(0,0,0,0.20)",
      }
    }
  });

  let center = ['40%', '60%']

  let option = {
    legend: {
      icon: "circle",
      itemWidth: 8,
      itemHeight: 8,
      top: '45%',
      orient: 'vertical',
      right: 30,
      itemGap: 30,
      textStyle: {
        color: "#ffffff"
      },
      data: barData,
    },
    series: [
      // 主要展示层的
      {
        radius: ['20%', '55%'],
        center: center,
        type: 'pie',
        hoverAnimation: false,
        label: {
          normal: {
            formatter: '{d}%({c})',
            color: "#ffffff"
          }
        },
        labelLine: {
          normal: {
            show: true,
            length: 10,
            smooth: true,
            lineStyle: {
              type: 'solid',
              width: 1
            }
          }
        },
        itemStyle: {
          normal: {
            borderWidth: 2,
            borderColor: "#0C233A",
          }
        },
        data: RealData,

      },
      // 边框的设置
      {
        radius: ['20%', '33%'],
        center: center,
        type: 'pie',
        hoverAnimation: false,
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        animation: false,
        tooltip: {
          show: false
        },
        data: borderData
      }
    ]
  };

  return option
}



// WEBPACK FOOTER //
// ./src/modules/tenantManager/dashboard/onlineDeviceChat/onlineDeviceChat.js